module.exports = __webpack_public_path__ + "img/zhanyu.c2e4e144.png";